import { ReactNode, useContext } from "react";
import { ThemeProvider } from "@emotion/react";
import theme from "../../theme";
import { CustomModalContext, LayoutBarContext } from "../../contexts";
import CustomModal from "../UIElements/CustomModal/CustomModal";
import "../components-styles.scss";

export default function Layout({ children }: { children: ReactNode }) {
    const { content } = useContext(LayoutBarContext);

    const {
        modal: { content: customModalContent, title },
    } = useContext(CustomModalContext);

    return (
        <ThemeProvider theme={theme}>
            <header></header>
            <main style={{ overflow: "hidden" }}>
                {content}
                <CustomModal title={title}>{customModalContent}</CustomModal>
            </main>
        </ThemeProvider>
    );
}
